<template>
  <div class="batch-import-page">
    <crumb-tit>
      <span slot="breadTit">{{ $t('message["1729"]') }}</span>
      <span slot="secondTit">{{ $t('message["1729"]') }}</span>
    </crumb-tit>

    <a-alert
      type="info"
      class="custom-alert clearfix"
    >
      <div
        slot="description"
      >
        <i class="iconfont iconicon-test68-copy fs-info fl" />
        {{ $t('message["1731"]') }}
      </div>
    </a-alert>

    <div class="tool-wrap">
      <a-button
        type="primary"
        @click="handleAdd"
      >
        {{ $t('message["1746"]') }}
      </a-button>
    </div>

    <table-list
      ref="tableList"
      @toggleEdit="toggleEdit"
    />
    <RulesModal
      :visible.sync="showModal"
      :edit-id="editId"
    />
  </div>
</template>

<script>
import CrumbTit from '@/components/pc/config/CrumbTit'
import TableList from './List'
import RulesModal from './RulesModal'

export default {
  components: {
    CrumbTit,
    TableList,
    RulesModal
  },
  data () {
    return {
      showModal: false,
      editId: null
    }
  },
  computed: {
    documentTitle () {
      let { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      projectname && (projectname = ' - ' + projectname)
      comname && (comname = ' - ' + comname)
      document.title = this.$t('message["1729"]') + projectname + comname
      return this.$t('message["1729"]') + projectname + comname
    }
  },
  watch: {
    documentTitle: {
      handler (val) {
        document.title = val
      },
      immediate: true
    }
  },
  methods: {
    handleAdd () {
      this.showModal = true
      this.editId = undefined
    },
    toggleEdit (id) {
      this.showModal = true
      this.editId = id
    }
  }
}
</script>

<style lang="scss" scoped>
.crumb-title {
  margin-bottom: 16px;
}
.tool-wrap {
  margin: 24px 0;
}
</style>
